import { FC } from "react";

import { ChartLabel } from "../ChartLabel/ChartLabel";

import { CustomBlockProps } from "./CustomBlock.type";

const CustomBlock: FC<CustomBlockProps> = ({ id, data, chartLabel }) => {
	const { title, component, props, showChartLabel = true } = data;

	const Component = component;

	return (
		<div id={id}>
			{showChartLabel && <ChartLabel label={chartLabel} />}
			{/* Optional: title */}
			{typeof title === "string" && title.trim().length > 0 ? <h3 className="mb-4" dangerouslySetInnerHTML={{ __html: title }} /> : null}

			<Component {...props} />
		</div>
	);
};

export { CustomBlock };
